export const lerp = (start, end, amount) => (1 - amount) * start + amount * end;
